import { generateClient } from 'aws-amplify/data';
import type { Schema } from '../../amplify/data/resource';

export type { Schema };
export const client = generateClient<Schema>({ authMode: 'apiKey' });
export const authClient = generateClient<Schema>({ authMode: 'userPool' });
